<template>
  <div>
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="6" class="pt-0 pb-0">
            <v-text-field
                label="Condição"
                :value="condition"
                :readonly="true"
                outlined
                dense
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="pt-0 pb-0">
            <v-text-field
                label="Ação"
                :value="action"
                :readonly="true"
                outlined
                dense
            ></v-text-field>
          </v-col>
        </v-row>

        <template v-if="!isWebhook">
          <v-row>
            <v-col cols="12" class="pt-0 pb-0">
              <v-text-field
                label="Assunto"
                :value="subject"
                :readonly="true"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="pt-0 pb-0">
              <v-text-field
                  label="Para"
                  :value="to"
                  :readonly="true"
                  outlined
                  dense
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col md="12" cols="12">
              <quill-editor
                :content="body"
                :options="editorOption"
              />
            </v-col>
          </v-row>
        </template>

        <template v-else>
          <v-row>
            <v-col cols="12" sm="3" class="pt-0 pb-0">
              <v-text-field
                label="Método"
                :value="webhookMethod"
                :readonly="true"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="9" class="pt-0 pb-0">
              <v-text-field
                label="URL"
                :value="webhookUrl"
                :readonly="true"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row v-if="webhookAuthType && webhookAuthType !== 'none'">
            <v-col cols="12" class="pt-0 pb-0">
              <v-text-field
                label="Autenticação"
                :value="webhookAuthLabel"
                :readonly="true"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row v-if="webhookHeaders.length">
            <v-col cols="12" class="pt-0 pb-0">
              <div class="description-text mb-2">Headers</div>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Header</th>
                      <th class="text-left">Valor</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in webhookHeaders" :key="`h-${i}`">
                      <td>{{ item.key }}</td>
                      <td>{{ item.value }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>

          <v-row v-if="webhookQueryParams.length">
            <v-col cols="12" class="pt-0 pb-0">
              <div class="description-text mb-2">Query Params</div>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Parâmetro</th>
                      <th class="text-left">Valor</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in webhookQueryParams" :key="`qp-${i}`">
                      <td>{{ item.key }}</td>
                      <td>{{ item.value }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>

          <v-row v-if="webhookBodyMode && webhookBodyMode !== 'none'">
            <v-col cols="12" class="pt-0 pb-0">
              <div class="description-text mb-2">
                Body ({{ webhookBodyModeLabel }})
              </div>

              <v-textarea
                v-if="webhookBodyText"
                :value="webhookBodyText"
                :readonly="true"
                outlined
                dense
                auto-grow
                rows="6"
                class="mono"
              ></v-textarea>

              <v-simple-table v-else-if="webhookBodyForm.length" dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Campo</th>
                      <th class="text-left">Valor</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in webhookBodyForm" :key="`bf-${i}`">
                      <td>{{ item.key }}</td>
                      <td>{{ item.value }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>

              <div v-else-if="webhookTemplateFields.length">
                <v-chip
                  v-for="(field, i) in webhookTemplateFields"
                  :key="`tf-${i}`"
                  small
                  outlined
                  class="ma-1"
                >
                  {{ field }}
                </v-chip>
              </div>
            </v-col>
          </v-row>

          <v-row v-if="webhookOptions">
            <v-col cols="12" sm="4" class="pt-0 pb-0">
              <v-text-field
                label="Timeout (s)"
                :value="webhookOptions.timeout"
                :readonly="true"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" class="pt-0 pb-0">
              <v-text-field
                label="Tentativas"
                :value="webhookOptions.retry_attempts"
                :readonly="true"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" class="pt-0 pb-0">
              <v-text-field
                label="Intervalo (s)"
                :value="webhookOptions.retry_delay"
                :readonly="true"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row v-if="hasWebhookResponse">
            <v-col cols="12" class="pt-0 pb-0">
              <v-divider class="mb-3"></v-divider>
              <div class="description-text mb-2">Resposta do Webhook</div>
            </v-col>

            <v-col cols="12" sm="4" class="pt-0 pb-0">
              <v-chip
                :color="webhookResponse.success ? 'success' : 'error'"
                small
                dark
              >
                <v-icon left small>
                  {{ webhookResponse.success ? 'mdi-check-circle' : 'mdi-alert-circle' }}
                </v-icon>
                {{ webhookResponse.success ? 'Sucesso' : 'Falha' }}
              </v-chip>
            </v-col>

            <v-col cols="12" sm="8" class="pt-0 pb-0">
              <v-text-field
                label="Status Code"
                :value="webhookResponse.status_code"
                :readonly="true"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-col v-if="webhookResponse.error" cols="12" class="pt-0 pb-0">
              <v-textarea
                label="Erro"
                :value="webhookResponse.error"
                :readonly="true"
                outlined
                dense
                auto-grow
                rows="2"
                color="error"
              ></v-textarea>
            </v-col>

            <v-col v-if="webhookResponseBody" cols="12" class="pt-0 pb-0">
              <v-textarea
                label="Response Body"
                :value="webhookResponseBody"
                :readonly="true"
                outlined
                dense
                auto-grow
                rows="6"
                class="mono"
              ></v-textarea>
            </v-col>
          </v-row>
        </template>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
export default {
  components: {
    quillEditor,
  },
  props: {
    condition: {
      type: String,
      default: ""
    },
    action: {
      type: String,
      default: ""
    },
    to: {
      type: String,
      default: ""
    },
    subject: {
      type: String,
      default: ""
    },
    body: {
      type: String,
      default: ""
    },
    action_value: {
      type: [Object, Array, String],
      default: () => ({})
    },
    webhook_response: {
      type: [Object, String],
      default: () => ({})
    },
  },
  data() {
    return {
      loadingInteraction: true,
      loadingDeleteBtn: false,
      dialog: false,
      editorOption: {
        modules: {
          toolbar: [
            [{ size: ["small", false, "large", "huge"] }],
            ["bold", "italic", "underline"],
            ["link", "image"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ["clean"]
          ]
        }
      },
    };
  },

  computed: {
    isWebhook() {
      return typeof this.action === "string" &&
        this.action.toLowerCase().includes("webhook");
    },
    webhookData() {
      const raw = this.action_value;
      if (!raw) return {};
      if (typeof raw === "string") {
        try {
          return JSON.parse(raw);
        } catch (e) {
          return {};
        }
      }
      return raw;
    },
    webhookUrl() {
      return this.webhookData.url || "";
    },
    webhookMethod() {
      const verb = this.webhookData.http_verb || "";
      return verb ? verb.toUpperCase() : "";
    },
    webhookAuthType() {
      return this.webhookData.auth && this.webhookData.auth.type
        ? this.webhookData.auth.type
        : "none";
    },
    webhookAuthLabel() {
      const map = {
        none: "Nenhuma",
        basic: "Basic",
        bearer: "Bearer Token",
        api_key: "API Key"
      };
      return map[this.webhookAuthType] || this.webhookAuthType;
    },
    webhookHeaders() {
      return Array.isArray(this.webhookData.headers)
        ? this.webhookData.headers.filter(h => h && h.key)
        : [];
    },
    webhookQueryParams() {
      return Array.isArray(this.webhookData.query_params)
        ? this.webhookData.query_params.filter(p => p && p.key)
        : [];
    },
    webhookBody() {
      return this.webhookData.body || {};
    },
    webhookBodyMode() {
      return this.webhookBody.mode || "none";
    },
    webhookBodyModeLabel() {
      const map = {
        none: "Nenhum",
        raw: "Raw",
        form: "Form",
        template: "Template"
      };
      return map[this.webhookBodyMode] || this.webhookBodyMode;
    },
    webhookBodyText() {
      return this.webhookBodyMode === "raw" ? this.webhookBody.raw || "" : "";
    },
    webhookBodyForm() {
      return this.webhookBodyMode === "form" && Array.isArray(this.webhookBody.form)
        ? this.webhookBody.form.filter(f => f && f.key)
        : [];
    },
    webhookTemplateFields() {
      return this.webhookBodyMode === "template" &&
        Array.isArray(this.webhookBody.template_fields)
        ? this.webhookBody.template_fields
        : [];
    },
    webhookOptions() {
      return this.webhookData.options || null;
    },
    webhookResponse() {
      const raw = this.webhook_response;
      if (!raw) return {};
      if (typeof raw === "string") {
        try {
          return JSON.parse(raw);
        } catch (e) {
          return {};
        }
      }
      return raw;
    },
    hasWebhookResponse() {
      return this.webhookResponse && Object.keys(this.webhookResponse).length > 0;
    },
    webhookResponseBody() {
      const body = this.webhookResponse.response_body;
      if (body === null || body === undefined || body === "") return "";
      if (typeof body === "object") {
        try {
          return JSON.stringify(body, null, 2);
        } catch (e) {
          return String(body);
        }
      }
      try {
        const parsed = JSON.parse(body);
        return JSON.stringify(parsed, null, 2);
      } catch (e) {
        return String(body);
      }
    },
  },

  async mounted() {
  },
  methods: {
  }
};
</script>

<style scoped>
.btn-mais {
  color: white;
  font-size: 12px;
}

.card-text {
  font-weight: bold;
  font-size: 16px;
}

.description-text {
  font-weight: bold;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.6);
}

.text {
  font-size: 13px;
  font-weight: 400;
}

.align {
  display: flex;
  align-items: center;
}

.chat-container {
  overflow-y: auto;
  padding: 10px;
  border-radius: 10px;
}

.chat-container .titulo {
  font-size: 16px;
  text-align: center;
  font-weight: bold;
}

.chat-container .content {
  padding: 1px 10px 3px 10px;
  background-color: #00838f;
  border-radius: 10px;
  display: inline-block;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  max-width: 50%;
  word-wrap: break-word;
  color: white;
}

.content {
  margin: 0 15px;
}
.content p {
  margin: 0px;
}

.message {
  margin-bottom: 5px;
}

.divider-margin {
  padding: 8px;
}

.message.own {
  text-align: right;
}

.message.own .content {
  background-color: #445e93;
  color: white;
}

.small-date {
  font-size: 11px;
  color: #546e7a;
}

.titulo {
  margin-bottom: 10px;
}

.description-size {
  font-size: 0.875rem;
  line-height: 1.5;
}

.titulo-dialog {
  text-align: center;
  font-size: 20px;
}

.mono >>> textarea,
.mono {
  font-family: "Fira Code", "JetBrains Mono", monospace;
  font-size: 12px;
}

@media (max-width: 480px) {
  .chat-container .content {
    max-width: 60%;
  }
}
</style>
